"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoBanner = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const closeButton_svg_1 = __importDefault(require("../../../../assets/icons/closeButton.svg"));
const habitatMapLogo_svg_1 = __importDefault(require("../../../../assets/icons/habitatMapLogo.svg"));
const trackBannerEvent_1 = require("../../../../utils/trackBannerEvent");
const logic_1 = require("./logic");
const S = __importStar(require("./InfoBanner.style"));
const InfoBanner = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    // Decide once on mount so the roll/pick is stable for this page load.
    const [post, setPost] = (0, react_1.useState)(null);
    const [variant, setVariant] = (0, react_1.useState)(null);
    const recorded = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(() => {
        if ((0, logic_1.shouldShow)()) {
            setVariant((0, logic_1.pickVariant)());
            setPost((0, logic_1.pickPost)());
        }
    }, []);
    (0, react_1.useEffect)(() => {
        if (post && variant && !recorded.current) {
            recorded.current = true;
            (0, logic_1.recordShown)(post);
            (0, trackBannerEvent_1.trackBannerEvent)({
                event: "banner_shown",
                variant,
                postSlug: post.postSlug,
            });
        }
    }, [post, variant]);
    if (!post || !variant)
        return null;
    // Canonical join key shared with HabitatMap (= their page.slug).
    const postSlug = post.postSlug;
    const handleDismiss = () => {
        (0, logic_1.recordDismissed)();
        (0, trackBannerEvent_1.trackBannerEvent)({ event: "banner_dismissed", variant, postSlug });
        setPost(null);
    };
    const handleClick = () => {
        (0, logic_1.recordClicked)();
        (0, trackBannerEvent_1.trackBannerEvent)({ event: "banner_clicked", variant, postSlug });
    };
    const href = (0, logic_1.withRef)(post.url, variant, postSlug);
    const logo = (react_1.default.createElement("img", { src: habitatMapLogo_svg_1.default, alt: t("infoBanner.habitatMapAlt") }));
    const closeButton = (onImage) => (react_1.default.createElement(S.CloseButton, { "$onImage": onImage, onClick: handleDismiss, "aria-label": t("infoBanner.dismiss") },
        react_1.default.createElement("img", { src: closeButton_svg_1.default, alt: "" })));
    // --- Minimal variant: whole card is one clickable link, no image/button ---
    if (variant === "minimal") {
        return (react_1.default.createElement(S.MinimalBanner, { role: "complementary", "aria-label": t("infoBanner.ariaLabel") },
            react_1.default.createElement(S.Accent, null),
            react_1.default.createElement(S.Body, null,
                react_1.default.createElement(S.MinimalTop, null,
                    react_1.default.createElement(S.HabitatBadge, null, logo),
                    closeButton(false)),
                react_1.default.createElement(S.Kicker, null, t("infoBanner.kicker")),
                react_1.default.createElement(S.MinimalLink, { href: href, target: "_blank", rel: "noopener noreferrer", onClick: handleClick },
                    react_1.default.createElement(S.Title, null, post.title)))));
    }
    // --- Full variant (default): image when available + read-more button ------
    const hasImage = Boolean(post.image);
    return (react_1.default.createElement(S.BannerWrapper, { "$compact": !hasImage, role: "complementary", "aria-label": t("infoBanner.ariaLabel") },
        hasImage ? (react_1.default.createElement(S.Thumb, null,
            react_1.default.createElement("img", { src: post.image, alt: "", decoding: "async" }),
            react_1.default.createElement(S.HabitatBadge, { "$onImage": true }, logo),
            closeButton(true))) : (react_1.default.createElement(S.Accent, null)),
        react_1.default.createElement(S.Body, null,
            !hasImage && (react_1.default.createElement(S.TopRow, null,
                react_1.default.createElement(S.HabitatBadge, null, logo),
                closeButton(false))),
            react_1.default.createElement(S.Kicker, null, t("infoBanner.kicker")),
            react_1.default.createElement(S.Title, null, post.title),
            react_1.default.createElement(S.ReadLink, { href: href, target: "_blank", rel: "noopener noreferrer", onClick: handleClick }, t("infoBanner.readMore")))));
};
exports.InfoBanner = InfoBanner;
